import { useQuery } from 'react-query';
import { getInvoiceDataUseCases } from '@subscriptions/composition';
import type { FiscalRegimesDto } from '@subscriptions/application/dtos';

/**
 * Hook for listing fiscal regimes catalog from SAT.
 *
 * @param options - Optional query configuration
 * @returns Query result with fiscal regimes catalog
 */
export const useFiscalRegimes = (options?: { enabled?: boolean }) => {
  const { listFiscalRegimes } = getInvoiceDataUseCases();

  return useQuery<FiscalRegimesDto, Error>(['subscriptions', 'fiscal-regimes'], () => listFiscalRegimes.execute(), {
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: false,
  });
};
